/*
 * @Desc: 文件描述
 * @Author: simbawu
 * @Date: 2019-01-21 15:19:10
 * @LastEditors: jiayi zhu
 * @LastEditTime: 2021-02-04 15:23:25
 */
export default {
  postWisdomOrderCode(params) {
    return this.http(
      'Columbus',
      'post',
      '/api/v1/wisdom/orders/exchange',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @name 获取评测题接口
   * @returns product_id 产品ID
   */
  getWisdomSurvey(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/v2/wisdom/evaluations',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @name 提交测评题
   * @returns Object app_key、sku
   */
  postSurveyAnswers(params) {
    return this.http(
      'Columbus',
      'post',
      '/api/v2/wisdom/evaluations',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @name 获取每日营养素分析接口
   * @returns Object
   */
  getDailyNuturitionAnalysis(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/gensci/reports/diet_report',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @name 获取金赛食谱列表
   * @returns Object
   */
  getGensciRecipeList(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/gensci/meal_plan/weekly',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @name 获取用户NPS问卷状态
   * @returns Array
   */
  getNpsStatus(params) {
    return this.http(
      'columbus',
      'get',
      '/api/v1/nps/user_surveys/detail',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @name 获取NPS详情
   * @returns Object
   */
  getNpsDetail(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/v1/nps/user_surveys',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @name 提交NPS问卷
   * @returns Object
   */
  postNpsAnswers(params) {
    return this.http(
      'Columbus',
      'post',
      '/api/v1/nps/user_surveys',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @Desc: 获取便便记录评测题
   * @Author: simbawu
   */
  getColumbusPooEvaluationQuestions(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/v3/poo/evaluation_questions',
      params
    ).then(res => {
      return res;
    });
  },
  /**
   * @Desc: 获取测评用户信息
   * @Author: jiayi zhu
   */
  getWisdomUserMes() {
    return this.http(
      'Columbus',
      'get',
      '/api/v3/wisdom/users/profile'
    ).then(res => {
      return res;
    });
  }
};
